import { render, staticRenderFns } from "./SummaryDossier.vue?vue&type=template&id=6377615f&scoped=true&"
import script from "./SummaryDossier.vue?vue&type=script&setup=true&lang=js&"
export * from "./SummaryDossier.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SummaryDossier.vue?vue&type=style&index=0&id=6377615f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377615f",
  null
  
)

export default component.exports